
import { useState } from 'react'
import { Search } from 'lucide-react'
import { Input } from '@meiuca/ui-components'

interface GameSearchProps {
  onSearch: (query: string) => void
  placeholder?: string
}

export function GameSearch({ onSearch, placeholder = "Buscar por nome, local ou modalidade..." }: GameSearchProps) {
  const [query, setQuery] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSearch(query)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setQuery(value)
    onSearch(value)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Input
        type="text"
        value={query}
        onChange={handleChange}
        placeholder={placeholder}
        leftIcon={Search}
        fullWidth
      />
    </form>
  )
}